import styled from 'styled-components';
import HeaderContentLayout from '@copilot/common/pages/layouts/headerContent';

export const PaddedContent = styled(HeaderContentLayout.Content)`
	& {
		padding: ${(props) => props.theme['@card-padding-base']};
	}
`;
